module.exports = __webpack_public_path__ + "static/media/school_2.c79ae363.png";